import type {IntlMap} from '~/intl/ru'

type HttpStatusCode = 200 | 400 | 401 | 403 | 500

export type PropertyDescription = {
    type: string
    value: string | PropertyDescriptions
}

export type PropertyDescriptions = Record<string, PropertyDescription>

export type RequestBody = {
    [key in HttpStatusCode]: string[]
} & {
    required: boolean
    value: PropertyDescriptions
    contentType: 'multipart/form-data' | 'application/json'
    cUrl: string[]
    payload: string[]
}

export type Method = {
    description: string
    method: {
        url: string
        type: 'get' | 'post' | 'delete' | 'patch'
    }
    includesStatic?: boolean
    parameters?: {
        search?: PropertyDescriptions
        path?: PropertyDescriptions
        requestBody?: RequestBody
    }
    responses: {
        code: number
        title: string
        description?: string
        contentType?: string
        response: PropertyDescriptions
        value: string[]
    }[]
}

export type ApiMethods = {
    [key: string]: Method[]
}

export function loadApiDocumentationJSON(language: string) {
    return import(`~/public/static/api-documentation/api-doc.${language}.json`) as Promise<ApiMethods>
}

export const preparePath = (method: string) => method.replace(/[{}]/g, '').replace(/\W/g, '-') as keyof IntlMap['documentation']
